const ShapeImg = ({ width = 88, height = 108, imageUrl = '' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 88 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="img1"
          width="1"
          height="1"
          patternContentUnits="objectBoundingBox"
        >
          <image
            href={imageUrl}
            x="0"
            y="0"
            width="1"
            height="1"
            preserveAspectRatio="xMidYMid slice"
          />
        </pattern>
      </defs>
      <path
        d="M79.9935 16.5823C46.2334 -14.904 15.7018 5.48847 4.33626 20.2012H4.47969C1.71923 24.0364 0 29.4394 0 35.4257C0 43.5265 3.14825 50.5593 7.76467 54.084C3.14825 57.6088 0 64.6416 0 72.7423C0 78.6417 1.66966 83.9747 4.36009 87.7988H4.33626C4.44115 87.9346 4.54765 88.0708 4.65579 88.2075C5.00537 88.6774 5.37091 89.1225 5.75111 89.541C18.0019 103.923 47.1484 121.437 79.3313 92.0291C80.9068 91.0223 82.3356 89.6203 83.5582 87.9095L83.6649 87.7988H83.6367C86.3291 83.9743 88.0001 78.6394 88.0001 72.7377C88.0001 64.6369 84.8518 57.6041 80.2354 54.0794C84.8518 50.5546 88.0001 43.5218 88.0001 35.4211C88.0001 29.4372 86.2822 24.0361 83.5237 20.2012H83.6649C83.4554 19.9834 83.246 19.7677 83.0367 19.5541C82.1173 18.3869 81.0955 17.3856 79.9935 16.5823Z"
        fill="url(#img1)"
      />
    </svg>
  );
};

export default ShapeImg;
